// extracted by mini-css-extract-plugin
export default {"dlListItem":"src-js-common-components-formatters-ListFormatter---dlListItem---uA2Yz"};